// src/pages/Admin/Dashboard/Events/Events.jsx

import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useScrollToTop from "../../../../hooks/useScrollToTop";
import useEvents from "./hooks/useEvents";

import EventDetails from "./components/EventDetails";
import EventDrawer from "./components/EventDrawer";
import EventForm from "./components/EventForm";
import EventsGrid from "./components/EventsGrid";
import EventsHero from "./components/EventsHero";
import EventsStats from "./components/EventsStats";
import EventsToolbar from "./components/EventsToolbar";

export default function Events() {
  useScrollToTop();

  const {
    loading,
    saving,
    filters,
    setFilter,
    events,
    filteredEvents,
    selectedEvent,
    drawerMode,
    deleteCandidateId,
    stats,
    actions,
  } = useEvents();

  return (
    <div className="space-y-6">
      <EventsHero
        loading={loading}
        total={events.length}
        activeCount={stats.active}
        onCreate={actions.openCreateDrawer}
        onRefresh={actions.refreshEvents}
      />

      <EventsStats loading={loading} stats={stats} />

      <EventsToolbar
        loading={loading}
        filters={filters}
        setFilter={setFilter}
        totalCount={events.length}
        filteredCount={filteredEvents.length}
        onCreate={actions.openCreateDrawer}
        onRefresh={actions.refreshEvents}
      />

      <EventsGrid
        loading={loading}
        events={filteredEvents}
        deleteCandidateId={deleteCandidateId}
        onDetails={actions.openDetailsDrawer}
        onEdit={actions.openEditDrawer}
        onAskDelete={actions.askDelete}
        onCancelDelete={actions.cancelDelete}
        onConfirmDelete={actions.confirmDelete}
        onToggleActive={actions.toggleActive}
        onToggleRegister={actions.toggleRegister}
      />

      <EventDrawer
        open={Boolean(drawerMode)}
        mode={drawerMode}
        event={selectedEvent}
        onClose={actions.closeDrawer}
      >
        {drawerMode === "details" && selectedEvent && (
          <EventDetails
            event={selectedEvent}
            onEdit={() => actions.openEditDrawer(selectedEvent)}
            onClose={actions.closeDrawer}
          />
        )}

        {drawerMode === "create" && (
          <EventForm
            mode="create"
            saving={saving}
            onSubmit={actions.createEvent}
            onClose={actions.closeDrawer}
          />
        )}

        {drawerMode === "edit" && selectedEvent && (
          <EventForm
            mode="edit"
            event={selectedEvent}
            saving={saving}
            onSubmit={actions.updateEvent}
            onClose={actions.closeDrawer}
          />
        )}
      </EventDrawer>

      <ToastContainer position="bottom-right" theme="colored" />
    </div>
  );
}